import { get, qs } from './http.ts';

export type ReleaseOs = 'windows' | 'darwin' | 'linux';
export type ReleaseArch = 'amd64' | 'arm64';

export interface Artifact {
  os: ReleaseOs;
  arch: ReleaseArch;
  kind: string;
  file: string;
  size: number;
  sha256: string;
  label: string;
  url: string;
}

export interface Release {
  version: string;
  channel: string;
  notes: string | null;
  released_at: string;
  is_current: boolean;
  artifacts: Artifact[];
}

export interface LatestResult {
  release: Release | null;
  recommended: Artifact | null;
  detected: { os: string; arch: string } | null;
}

/** 다운로드 페이지는 로그인 없이 열려 있다 — 새 PC 에 설치하려면 먼저 받아야 하므로. */
export const latest = (os?: ReleaseOs, arch?: ReleaseArch): Promise<LatestResult> =>
  get(`/client/latest${qs({ os, arch })}`);

export const listReleases = (): Promise<{ items: Release[] }> => get('/client/releases');
